import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import * as z from "zod";

const resetReturnPresentationSchema = z.object({
  presented: z.literal(true),
  returnType: z.nativeEnum(ReturnTypeEnum),
  flowId: z.string().optional(),
  recommendedStep: z.number().optional(),
  recommendedLabel: z.string().min(1).optional(),
  defaultStep: z.number().optional(),
  defaultLabel: z.string().min(1).optional(),
  differsFromDefault: z.boolean().optional(),
  customerImpact: z.string().min(1).optional(),
  whyNotDefault: z.string().optional(),
});

const resetReturnRecommendationSchema = resetReturnPresentationSchema.extend({
  recommendedStep: z.number(),
  recommendedLabel: z.string().min(1),
  defaultStep: z.number(),
  defaultLabel: z.string().min(1),
  differsFromDefault: z.boolean(),
  customerImpact: z.string().min(1),
});

export type ResetReturnPresentation = z.infer<
  typeof resetReturnPresentationSchema
>;

export type ResetReturnRecommendationView = z.infer<
  typeof resetReturnRecommendationSchema
>;

export function parseResetReturnPresentation(
  output: unknown,
): ResetReturnPresentation | undefined {
  const parsed = resetReturnPresentationSchema.safeParse(output);
  return parsed.success ? parsed.data : undefined;
}

export function parseResetReturnRecommendation(
  output: unknown,
): ResetReturnRecommendationView | undefined {
  const parsed = resetReturnRecommendationSchema.safeParse(output);
  return parsed.success ? parsed.data : undefined;
}
